import { useState } from "react";
import { useEmailTemplates } from "../../settings-communication/api/hooks";
import type { EmailTemplate } from "../../settings-communication/api/types";
import {
  PickerShell,
  TemplateSearchList,
  type TemplateSearchResult
} from "./TemplatePicker";

const useEmailTemplateSearch = (
  search: string
): TemplateSearchResult<EmailTemplate> => {
  const { data, isLoading, isError } = useEmailTemplates({
    per_page: 100,
    order_by: "name",
    order_direction: "asc",
    ...(search ? { search } : {})
  });
  return { items: data?.items ?? [], isLoading, isError };
};

export const TemplatePickerButton = ({
  onSelect,
  disabled = false
}: {
  onSelect: (template: EmailTemplate) => void;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const { data: probe } = useEmailTemplates({ per_page: 1 });

  return (
    <PickerShell
      hidden={!probe?.total_count}
      disabled={disabled}
      open={open}
      onOpenChange={setOpen}
    >
      <TemplateSearchList
        label="Email templates"
        inputId="email-template-search"
        useTemplates={useEmailTemplateSearch}
        busy={false}
        onClose={() => setOpen(false)}
        onPick={(template) => {
          setOpen(false);
          onSelect(template);
        }}
      />
    </PickerShell>
  );
};
